import React from "react";

const SelectField = ({ name, label, placeholder, defaultValue, items, onChange, error }) => {
  return (
    <div className="d-flex flex-column gap-2 mb-2">
      <span className="text-black fs-normal">{label}</span>
      <select className="border-0 bg-grey2 py-2 px-2 rounded text-black fs-normal" name={name} defaultValue={defaultValue} onChange={onChange} placeholder={placeholder ?? "Enter text..."}>
        {items?.map((it) => (
          <option key={it.value} value={it.value}>
            {it.label}
          </option>
        ))}
      </select>
      <span className="text-danger fs-sm">{error || ""}</span>
    </div>
  );
};

export default SelectField;
